import type { ITemplate } from 'core/utils/templates'

export enum Visibility {
  IsVisible = 'is-visible',
  NotVisible = 'not-visible',
  IsUsable = 'is-usable'
}

export type TemplatesSorted = Record<Visibility, ITemplate[]>

export const initialTemplatesSorted: TemplatesSorted = {
  [Visibility.IsVisible]: [],
  [Visibility.NotVisible]: [],
  [Visibility.IsUsable]: []
}
